import { render, staticRenderFns } from "./ComixSearch.vue?vue&type=template&id=70bedf36&"
import script from "./ComixSearch.vue?vue&type=script&lang=js&"
export * from "./ComixSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports